'use es6';

import { Record } from 'immutable';
class UserPreferences extends Record({
  primaryLanguage: undefined,
  secondaryLanguage: undefined
}, 'UserPreferences') {}
export default UserPreferences;